import React, { useState } from 'react';
import { Button, Dropdown, Icon, Menu, Tooltip } from 'antd';
import cn from 'classnames';
import styles from './SortDropdown.module.scss';

const SortDropdown = ({ sortData, setSortData, items, btnClassName }) => {
  const [visible, setVisible] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([sortData.value]);

  const handleMenuClick = ({ key, item }) => {
    setSortData(item.props.value);
    setSelectedKeys([key]);
    setVisible(false);
  };

  const menu = (
    <Menu onClick={handleMenuClick} selectedKeys={selectedKeys}>
      {items.map((item) => (
        <Menu.Item key={item.value} value={item}>
          {item.content}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      visible={visible}
      onVisibleChange={setVisible}
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
    >
      <Tooltip title="Сортировка">
        <Button className={cn(styles.btn, btnClassName)}>
          {sortData.content}
          <Icon type={visible ? 'caret-up' : 'caret-down'} />
        </Button>
      </Tooltip>
    </Dropdown>
  );
};

export default SortDropdown;
